import React from 'react';
import { motion } from 'framer-motion';
import { Zap } from 'lucide-react';

const XPProgressBar = ({ currentXP, level, showLabel = true }) => {
  const xpForCurrentLevel = (level - 1) * 200;
  const xpForNextLevel = level * 200;
  const xpInCurrentLevel = currentXP - xpForCurrentLevel;
  const xpNeededForLevel = xpForNextLevel - xpForCurrentLevel;
  const progress = (xpInCurrentLevel / xpNeededForLevel) * 100;

  return (
    <div className="w-full" data-testid="xp-progress-bar">
      {showLabel && (
        <div className="flex justify-between items-center mb-2">
          <span className="text-sm font-bold text-white uppercase tracking-wide font-heading">
            Level {level}
          </span>
          <span className="text-sm font-medium text-white/90 font-body">
            {xpInCurrentLevel} / {xpNeededForLevel} XP
          </span>
        </div>
      )}

      <div className="relative w-full h-8 bg-white border-4 border-ssdp-navy rounded-full overflow-hidden shadow-[4px_4px_0px_0px_rgba(30,58,89,1)]">
        <motion.div
          initial={{ width: 0 }}
          animate={{ width: `${progress}%` }}
          transition={{ duration: 1, ease: 'easeOut' }}
          className="absolute inset-y-0 left-0 bg-gradient-to-r from-ssdp-teal to-ssdp-purple flex items-center justify-end pr-2"
        >
          {progress > 20 && (
            <Zap className="w-4 h-4 text-white" fill="white" strokeWidth={0} />
          )}
        </motion.div>
      </div>
    </div>
  );
};

export default XPProgressBar;